<template>
  <div class="col-md-6">
    <cards class="previews-order-card">
      <order-item :order="order"></order-item>
      <div class="box buttons">
        <el-button
          class="col-md-12"
          :disabled="loadingStatus"
          @click="onViewStatusClick(order)"
        >
          <i v-if="loadingStatus" class="k-icon-spin4 animate-spin"></i>
          {{ $t("button.view_status") }}</el-button
        >
      </div>
    </cards>
  </div>
</template>

<script>
import { Button, Cards } from "@/components";
import { OrderItem } from '@/views/partial'
import { ORDER_STATUS } from "@/utilities/enums";
export default {
  name: "current-order-item",
  components: {
    [Button.name]: Button,
    Cards,
    OrderItem
  },
  data() {
    return {
      loadingStatus: false,
    };
  },
  methods: {
    onViewStatusClick(order) {
      if (order && order.order_status < ORDER_STATUS.REJECTED) {
        this.loadingStatus = true;
        let params = {
          order_id: this.order.id,
        };
        this.fetchTrackingOrder(params)
          .then((response) => {
            this.$root.$emit("VIEW_STATUS", response.data);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.loadingStatus = false;
          });
      } else {
        this.$root.$emit("VIEW_STATUS", {
          id: order.id,
          where2_enabled: order.where2_enabled,
          location: order.location,
          orderWhere2: order.orderWhere2,
          order_type: order.order_type,
          order_status: order.order_status,
          orderStatusHistory: order.orderStatusHistory,
        });
      }
    },
  },
  props: {
    order: Object,
  },
};
</script>
